// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__39WD3","title":"InfoRow_title__PA0vT"};